import axios from 'axios';
import Cookie from 'js-cookie';
import { cloneDeep } from 'lodash';

import siteConfig from 'config/Config';
import Util from 'utils';
import { Toast, Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import { Loading } from 'pubBiz';
import { hex_md5 } from 'utils/md5';
import { wechatLogin } from 'utils/wxUtils';
import { getDomainCodeByAreaCode } from 'utils/constants';

axios.defaults.timeout = 180000;
// axios.defaults.baseURL = '';
axios.defaults.withCredentials = true;

let canRun = true;
let alertInstance = '';
const isWeChat = Util.isWeiXin();
const isXM = Util.isXM(); // 享脉

/**
 * 获取通用的持久化Headers
 */
const getPersistedHeaders = () => {
  const headers = {};
  Util.PERSIST_HEADER_CONFIG.forEach((item) => {
    const storage = item.storage === 'session' ? sessionStorage : localStorage;
    const key = item.storageKey || item.key;
    const val = storage.getItem(key);

    // Header键名
    const headerKey = item.headerKey || item.key;

    if (val) {
      headers[headerKey] = val;
    } else if (item.defaultValue !== undefined) {
      headers[headerKey] = item.defaultValue;
    }
  });
  return headers;
};
// #endregion

/**
 * 处理登录失效
 */
function handle401(type) {
  if (sessionStorage.getItem('queryQuestUserId')) {
    return;
  }
  console.log('request401,测试', type);
  if (!canRun) {
    return;
  }
  canRun = false;

  // 微信环境下接口报401，处理跳转到引导绑定页，引导绑定页返回统一回到首页@叶秋
  if (isWeChat && !Stores.AppMod.workWechatAgentId) {
    console.log('request401 微信,测试', type);
    // 清楚用户本地数据
    Stores.AppMod.clearData();
    Util.setLocalCache(siteConfig.localStorageKeys.wechatTipBackHome, true);
    const route = window.location.href.split('#') || [];
    Util.setLocalCache(siteConfig.localStorageKeys.loginGoback, true);
    Util.setLocalCache(siteConfig.localStorageKeys.registerRoute, route[1] || '');
    wechatLogin();
  } else {
    console.log('request401 H5,测试', type);
    // 清楚用户本地数据
    Stores.AppMod.clearData();
    Util.setLocalCache(siteConfig.localStorageKeys.loginGoback, true);
    window.app.routerGoTo('/login');
  }
  setTimeout(() => {
    canRun = true;
  }, 1000);
}

/**
 * 设置链接里的内容
 */
function setLinkData(val) {
  if (Array.isArray(val)) {
    val.forEach((item) => {
      Util.getQueryString(item) && sessionStorage.setItem(item, Util.getQueryString(item));
    });
  } else {
    Util.getQueryString(val) && sessionStorage.setItem(val, Util.getQueryString(val));
  }
}
// 域名判断站点
function getSystemSiteCode() {
  // 站点列表
  const systemList = [
    {
      host: 'nblcdz.cn',
      systemCode: 'LY'
    },
    {
      host: 'sanshengjk.cn',
      systemCode: 'LY'
    },
    {
      host: 'sbnh5.uat.yofoys.cn',
      systemCode: 'LY'
    },
    {
      host: 'sbnh5.uat2.yofoys.cn',
      systemCode: 'LY'
    },
    {
      host: 'h5.uat3.nblcdz.cn',
      systemCode: 'LY'
    },
    {
      host: 'xbailing.com',
      systemCode: 'XBL'
    },
    {
      host: 'xbailingh5.uat3.yofoys.cn',
      systemCode: 'XBL'
    },
    {
      host: 'h5.nbmqdz.com',
      systemCode: 'DWCS'
    },
    {
      host: 'h5.uat3.nbmqdz.com',
      systemCode: 'DWCS'
    },
    {
      host: 'h5.uat5.nbmqdz.com',
      systemCode: 'DWCS'
    },
    {
      host: 'h5.nbxpdz.com',
      systemCode: 'WLM'
    }
  ];
  const location = window.location;
  const { host } = location;
  if (host) {
    let newHost = systemList.find((item) => {
      return item.host == host || host.indexOf(item.host) > -1;
    });
    if (newHost) {
      sessionStorage.setItem('systemCode', newHost.systemCode || '');
    } else {
      // 临时注释，为兼容非域名内容，直接传站点信息
      // sessionStorage.removeItem('systemCode')
    }
  }
}

// 替换CDN地址
const replaceCDN = (data) => {
  if (!data) {
    return data;
  }
  let returnData = JSON.stringify(data)
    .replace(/yofoto-test.obs.cn-east-2.myhuaweicloud.com/g, 'image-test.yofoto.cn')
    .replace(/bucket-prod.obs.cn-east-2.myhuaweicloud.com/g, 'image.yofogo.com')
    .replace(/bucket-uat.obs.cn-east-2.myhuaweicloud.com/g, 'image-uat.yofoto.cn');
  return JSON.parse(returnData);
};

/**
 * 获取渠道标识
 * 根据 appId 判断渠道，特殊处理 gcc 渠道
 * @returns {string} 渠道标识
 */
const getChannel = (config) => {
  // 从 localStorage 获取 appId（由 AppMod 的 checkFreeLogin 方法设置）
  const appId = Util.getLocalCache('member_appId');

  // 特殊处理：appId 为 10980413 时返回 gcc 渠道
  if (appId === '10980413') {
    return 'gcc';
  }

  // 享脉环境返回 b2c_web_h5_xm，否则使用配置的 channel 或默认值
  return isXM ? 'b2c_web_h5_xm' : (config && config.channel) || 'b2c_web_h5';
};

const extractNumbersFromUrl = (url) => {
  // 匹配纯数字内容的正则
  const regex = /\b\d+\b/g;
  const matches = url.match(regex);
  return matches ? matches : [];
};
window.getHeaders = (config) => {
  // url配置
  let signUrl = `${config.version || ''}${config.url}`; // 验签地址

  if (signUrl && signUrl.indexOf('?') > -1) {
    signUrl = signUrl.split('?')[0]; // 使用split方法将URL分割成两部分，取第一部分作为基础URL
  }
  // 不传入，则默认为空对象
  let headers = config || {};
  // 解决ie不重新请求问题

  headers = {
    ...headers,
    ...getPersistedHeaders(),
    language: localStorage.getItem('lng') || 'cn',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: -1,
    channel: getChannel(config),
    'Sign-version': '1.0.45' // 验签版本
  };
  let auth =
    Util.getLocalCache(siteConfig.localStorageKeys.member_token) ||
    Cookie.get(siteConfig.localStorageKeys.member_token);
  if (auth) {
    headers['Access-Token'] = auth;
  }
  // 域名判断站点
  getSystemSiteCode();
  if (Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode')) {
    headers['System-Code'] =
      Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode');
  } else if (auth && sessionStorage.getItem('systemCode') && !sessionStorage.getItem('LYFlag')) {
    // sessionStorage.removeItem('systemCode')
  }

  if (
    config.method == 'post_json' ||
    config.method == 'POST_JSON' ||
    config.method == 'put_json' ||
    config.method == 'PUT_JSON' ||
    config.method == 'POST'
  ) {
    if (config.method == 'post_json' || config.method == 'POST_JSON' || config.method == 'POST') {
      config.method = 'post';
    } else {
      config.method = 'put';
    }
    headers['Content-type'] = 'application/json;charset=UTF-8';

    if (config.data && typeof config.data === 'object') {
      // 转换成json字符串
      config.data = JSON.stringify(config.data);
    }
  }

  // Content-type默认为表单提交
  if (!headers['Content-type']) {
    headers['Content-type'] = 'application/x-www-form-urlencoded';
  }

  // 请求headers中增加Application-Key
  if (!headers['Application-Key']) {
    headers['Application-Key'] = siteConfig.appKey;
  }
  // 国际标识
  const isInternationalized =
    [
      'cxwygj.com',
      'h5.cxwygj.com',
      'intl.yofogo.com',
      'foreign.yofogo.com',
      'intl.fanxinggj.com',
      'foreign.fanxinggj.com',
      'intl.fanxinggj.com',
      'foreign.fanxinggj.com',
      'foreignh5.uat3.yofoys.cn'
    ].includes(location.host) ||
    location.hash.indexOf('isInter') != -1 ||
    localStorage.getItem('isInter') ||
    (localStorage.getItem('lng') || 'cn') != 'cn' ||
    (isXM && ['h5.test.yofoys.cn'].includes(location.host));
  headers['International'] = isInternationalized ? 1 : 0;

  // 加密
  let getJson = null;
  let getJsonStr = null;
  let postJson = null;
  let postJsonStr = null;
  try {
    if (typeof config.params === 'string') getJson = JSON.parse(config.params);
    else if (typeof config.params === 'object' && config.params)
      getJson = JSON.parse(JSON.stringify(config.params));
    const urlParams = config.url.split('?')[1];
    if (urlParams) {
      urlParams.split('&').forEach((p) => {
        const obj = p.split('=');
        if (!getJson) getJson = {};
        if (getJson[obj[0]] == undefined) getJson[obj[0]] = obj[1];
      });
    }
    if (getJson) {
      getJson = Util.sortParams(getJson);
      getJsonStr = JSON.stringify(getJson);
    }
  } catch (e) {}
  if (config.method && config.method.toLowerCase() != 'get') {
    try {
      if (typeof config.data === 'string') postJson = JSON.parse(config.data);
      else if (typeof config.data === 'object' && config.data)
        postJson = JSON.parse(JSON.stringify(config.data));
      postJsonStr = JSON.stringify(postJson) || '';
    } catch (e) {}
  }
  const time = new Date().getTime();
  headers['biz-timestamp'] = time;
  headers['biz-sign'] = hex_md5(
    `${signUrl}${'biz-timestamp'}${time}${getJsonStr && getJsonStr != 'null' && getJsonStr !== '{}' ? getJsonStr : ''}${postJsonStr && postJsonStr != 'null' && postJsonStr !== '{}' ? postJsonStr : ''}`
  ).toLowerCase();
  headers['biz-sign1'] =
    `${signUrl}${'biz-timestamp'}${time}${getJsonStr && getJsonStr != 'null' && getJsonStr !== '{}' ? getJsonStr : ''}${postJsonStr && postJsonStr != 'null' && postJsonStr !== '{}' ? postJsonStr : ''}`;

  delete headers['body'];
  delete headers['params'];
  delete headers['url'];
  return headers;
};
// 处理请求参数，自动添加 domainCode和cellphoneDomainCode
const handleDomainCode = (params) => {
  if (!params || typeof params !== 'object') return false;
  // if (!!params.areaCode && !!params.domainCode) return false; // 已存在domainCode，则不处理
  let hasChange = false;
  // 递归处理各层级的国际区号，只有匹配到国家/地区区号时才转换，避免误伤地址区域码
  const handleAreaCode = (target) => {
    if (target && target.areaCode) {
      const domainInfo = getDomainCodeByAreaCode(target.areaCode);
      if (domainInfo.code) {
        target.domainCode = domainInfo.domainAbbreviation;
        target.areaCode = domainInfo.code;
        hasChange = true;
      }
    }
  };
  // 遍历参数对象/数组，查找任意层级下的 areaCode
  const traverseAreaCode = (target) => {
    if (!target || typeof target !== 'object') return;
    if (Array.isArray(target)) {
      target.forEach(traverseAreaCode);
      return;
    }
    handleAreaCode(target);
    Object.keys(target).forEach((key) => {
      traverseAreaCode(target[key]);
    });
  };
  traverseAreaCode(params);
  if (params.shopContactInfoDto && params.shopContactInfoDto.cellphoneAreaCode) {
    params.shopContactInfoDto.cellphoneDomainCode = getDomainCodeByAreaCode(
      params.shopContactInfoDto.cellphoneAreaCode
    ).domainAbbreviation;
    params.shopContactInfoDto.cellphoneAreaCode = getDomainCodeByAreaCode(
      params.shopContactInfoDto.cellphoneAreaCode
    ).code;
    hasChange = true;
  }
  return hasChange;
};

/**
 * 如果登录了，就把token写入header
 * */
// #region 请求拦截
axios.interceptors.request.use(
  (config) => {
    // url配置
    let signUrl = `${config.version || '/v1'}/${config.url}`; // 验签地址
    if (config.hiddenV1) {
      signUrl = signUrl.replace('/v1/', '');
    }
    if (signUrl && signUrl.indexOf('?') > -1) {
      signUrl = signUrl.split('?')[0]; // 使用split方法将URL分割成两部分，取第一部分作为基础URL
    }
    config.url = siteConfig.apiAppName({
      url: config.url,
      host: config.host,
      isMock: config.isMock,
      version: config.version,
      isFengNiao: config.isFengNiao,
      fengNiaoParam: config.fengNiaoParam
    });
    if (config.hiddenV1) {
      config.url = config.url.replace('/v1/', '');
    }
    // 设置响应类型为json
    config.responseType = 'json';
    // 取出headers
    let headers = cloneDeep(config.headers);

    let auth =
      Util.getLocalCache(siteConfig.localStorageKeys.member_token) ||
      Cookie.get(siteConfig.localStorageKeys.member_token);

    // 不传入，则默认为空对象
    headers = headers || {};
    // 解决ie不重新请求问题
    headers = {
      ...headers,
      ...getPersistedHeaders(),
      language: localStorage.getItem('lng') || 'cn',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: -1,
      channel: getChannel(config),
      'Sign-version': '1.0.45' // 验签版本
    };

    if (auth) {
      headers['Access-Token'] = auth;
    }

    // 课程分享
    if (Util.getQueryString('Share') == 'yes') {
      headers.Share = 'yes';
    }
    // Loading.show()

    // 游客进来获取地址中的站点
    if (Util.getQueryString('systemCode')) {
      sessionStorage.setItem('systemCode', Util.getQueryString('systemCode'));
    }

    // 记录来源标识 目前是公众号来源需要记录
    if (Util.getQueryString('fromOrigin')) {
      sessionStorage.setItem('fromOrigin', Util.getQueryString('fromOrigin'));
    }

    // 记录企微应用id，有证明是从企微进入
    if (Util.getQueryString('agentId')) {
      sessionStorage.setItem('agentId', Util.getQueryString('agentId'));
    }
    // 记录分享人卡号 下单的时候传递
    if (
      Util.getQueryString('bindCardCode') &&
      (!sessionStorage.getItem('shareCardNo') ||
        (sessionStorage.getItem('shareCardNo') &&
          sessionStorage.getItem('shareCardNo') !== Util.getQueryString('bindCardCode')))
    ) {
      sessionStorage.setItem('shareCardNo', Util.getQueryString('bindCardCode'));
    }
    // 记录分享来源
    if (Util.getQueryString('ment') && !sessionStorage.getItem('mentFrom')) {
      try {
        sessionStorage.setItem('mentFrom', Util.getQueryString('ment'));
        const { id, cardCode } = Stores.AppMod.userInfo || {};
        const numbers = extractNumbersFromUrl(window.location.href);
        // 第一次进入埋点
        window.sensors.track('promotionSpecialPage', {
          location_url: window.location.hash,
          channal: 'H5',
          userId: id || '',
          cardCode: cardCode || '',
          special_page_id: Array.isArray(numbers) ? numbers[0] : ''
        });
      } catch (e) {}
    }
    // XY分享参数
    const fromTeamShareFlag = Util.getQueryString('fromTeamShareFlag') || '';
    if (!!fromTeamShareFlag || fromTeamShareFlag === 0) {
      localStorage.setItem('fromTeamShareFlag', fromTeamShareFlag);
    }

    // 拦截处理 areaCode 自动增加 domainCode和cellphoneDomainCode 参数
    if (config.params) {
      handleDomainCode(config.params);
    }
    if (config.data && typeof config.data === 'object') {
      handleDomainCode(config.data);
    } else if (config.data && typeof config.data === 'string') {
      try {
        let parsedData = JSON.parse(config.data);
        if (handleDomainCode(parsedData)) {
          config.data = JSON.stringify(parsedData);
        }
      } catch (e) {
        // 解析失败忽略
        console.warn('自动添加 domainAbbreviation 失败', e);
      }
    }
    // 域名判断站点
    getSystemSiteCode();
    // 子活动编号和主活动编号
    if (Util.getQueryString('subActivityId')) {
      sessionStorage.setItem('subActivityId', Util.getQueryString('subActivityId'));
      if (Util.getQueryString('id')) {
        sessionStorage.setItem('mainActivityId', Util.getQueryString('id'));
      } else {
        sessionStorage.setItem('mainActivityId', Util.getQueryStringBefore());
      }
      setLinkData(['subActivityChannel']);
      Util.getQueryString('cardCode') &&
        sessionStorage.setItem('cardCode', Util.getQueryString('cardCode'));
    }

    if (Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode')) {
      headers['System-Code'] =
        Util.getQueryString('systemCode') || sessionStorage.getItem('systemCode');
    } else if (auth && sessionStorage.getItem('systemCode') && !sessionStorage.getItem('LYFlag')) {
      // sessionStorage.removeItem('systemCode')
    }

    if (
      config.method == 'post_json' ||
      config.method == 'POST_JSON' ||
      config.method == 'put_json' ||
      config.method == 'PUT_JSON'
    ) {
      if (config.method == 'post_json' || config.method == 'POST_JSON') {
        config.method = 'post';
      } else {
        config.method = 'put';
      }
      headers['Content-type'] = 'application/json;charset=UTF-8';

      if (config.data && typeof config.data === 'object') {
        // 转换成json字符串
        config.data = JSON.stringify(config.data);
      }
    }

    // Content-type默认为表单提交
    if (!headers['Content-type']) {
      headers['Content-type'] = 'application/x-www-form-urlencoded';
    }

    // 请求headers中增加Application-Key
    if (!headers['Application-Key']) {
      headers['Application-Key'] = siteConfig.appKey;
    }
    // 国际标识
    const isInternationalized =
      [
        'cxwygj.com',
        'h5.cxwygj.com',
        'intl.yofogo.com',
        'foreign.yofogo.com',
        'intl.fanxinggj.com',
        'foreign.fanxinggj.com',
        'foreignh5.uat3.yofoys.cn'
      ].includes(location.host) ||
      location.hash.indexOf('isInter') != -1 ||
      localStorage.getItem('isInter') ||
      (localStorage.getItem('lng') || 'cn') != 'cn' ||
      (isXM && ['h5.test.yofoys.cn'].includes(location.host));
    headers['International'] = isInternationalized ? 1 : 0;

    // 加密
    let getJson = null;
    let getJsonStr = null;
    let postJson = null;
    let postJsonStr = null;
    try {
      if (typeof config.params === 'string') getJson = JSON.parse(config.params);
      else if (typeof config.params === 'object' && config.params)
        getJson = JSON.parse(JSON.stringify(config.params));
      const urlParams = config.url.split('?')[1];
      if (urlParams) {
        urlParams.split('&').forEach((p) => {
          const obj = p.split('=');
          if (!getJson) getJson = {};
          if (getJson[obj[0]] == undefined) getJson[obj[0]] = obj[1];
        });
      }
      if (getJson) {
        getJson = Util.sortParams(getJson);
        getJsonStr = JSON.stringify(getJson);
      }
    } catch (e) {}
    if (config.method && config.method.toLowerCase() != 'get') {
      try {
        if (typeof config.data === 'string') postJson = JSON.parse(config.data);
        else if (typeof config.data === 'object' && config.data)
          postJson = JSON.parse(JSON.stringify(config.data));
        postJsonStr = JSON.stringify(postJson) || '';
      } catch (e) {}
    }
    const time = new Date().getTime();
    headers['biz-timestamp'] = time;
    headers['biz-sign'] = hex_md5(
      `${signUrl}${'biz-timestamp'}${time}${getJsonStr && getJsonStr != 'null' && getJsonStr !== '{}' ? getJsonStr : ''}${postJsonStr && postJsonStr != 'null' && postJsonStr !== '{}' ? postJsonStr : ''}`
    ).toLowerCase();
    config.withCredentials = config.withCredentials != false;
    config.headers = headers;
    // console.log('request config: ', config, 'request data: ', config.data);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// #region 响应拦截
axios.interceptors.response.use(
  (response) => {
    const { resultCode, resultMsg } = response.data;

    // Loading.clear()
    // resultCode不等于0，并且Serv不要求释放处理时，在此统一处理

    if (`${resultCode}` != '0' && !response.config.ignoreErr) {
      Toast.hide();
      if (resultCode == 401) {
        handle401('success');
        return Promise.reject(response.data);
      }
      if (resultCode == '198401') {
        sessionStorage.removeItem('routerCount');
        sessionStorage.setItem('noNeedAutoLogined', '1');
        Util.setLocalCache('isGoToHome', true);
        Stores.AppMod.clearData();
        Util.setLocalCache(siteConfig.localStorageKeys.loginGoback, true);
        window.app.routerGoTo('/login');
        return Promise.reject(response.data);
      }
      !response.config.ignoreToast && Toast.fail(resultMsg, resultCode == '10000' ? 3 : 2);
      return Promise.reject(response.data);
    }

    let resJson = '';
    try {
      if (response.data) resJson = JSON.stringify(response.data).replace(/\.\d+/g, '');
    } catch (e) {}
    if (response.headers && response.headers['biz-sign'] && resJson) {
      const time = response.headers['biz-timestamp'];
      const sign = response.headers['biz-sign'];
      const customSign = hex_md5(`${'biz-timestamp'}${time}${resJson}`).toLowerCase();
      if (customSign != sign) {
        Toast.fail('验签失败', 2);
        // 上报异常信息
        window.sentry &&
          window.sentry.trackReport(
            {
              error: response.headers || {},
              extra: {
                errorType: '验签失败'
              }
            } || {}
          );
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ ...response.data, resultCode: -1, resultMsg: '验签失败' });
      }
    }

    if (response.config.returnAll) {
      return replaceCDN(response);
    }

    return replaceCDN(response.data);
  },
  (error) => {
    const errRes = error.response && error.response.data ? error.response.data : error;
    const { config = {}, status } = error.response || {};
    const statusCode = status;
    const { resultCode, resultMsg } = errRes || {};
    Toast.hide();
    let sentryError = new Error();
    sentryError.name = `request_http_${statusCode}`;
    window.sentry &&
      window.sentry.trackReport({
        error: sentryError,
        extra: {
          msg: JSON.stringify(error)
        }
      });
    if (statusCode == 401) {
      if (config.ignore401) {
        // handle401();
        return;
      }
      if (alertInstance) {
        return;
      }
      // alertInstance = Modal.alert('提示', '您的账号被其他用户登录，若非本人操作，请及时修改密码', [
      //   {
      //     text: '确定',
      //     onPress: () => {
      //       alertInstance.close();
      //       handle401();
      //     }
      //   },
      // ]);
      Toast.fail('请先登录', 1.5);
      const timer = setTimeout(function () {
        handle401();
        clearTimeout(timer);
      }, 1500);
    } else if ([400, 403, 500].includes(statusCode)) {
      Toast.fail('哎呀，当前人数太多了，重试一下看看', 1.5);
      // 上报异常信息
      window.sentry &&
        window.sentry.trackReport(
          {
            error,
            extra: {
              errorType: '网络请求异常'
            }
          } || {}
        );
    } else {
      // 非请求华为云图片颜色的报错，需要弹出报错信息（‘ITS.0210’是请求华为云图片颜色报404的错误码）
      if (errRes.code != 'ITS.0210' && resultMsg && resultMsg.indexOf('thematicType') == -1) {
        Toast.fail(resultMsg, 2);
      }
    }
    return Promise.reject(errRes);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/utils/request.js